import { recordStorefrontOrderPlaced } from "@/domain/storefront-analytics"
import { recordSuggestionConversions } from "@/lib/record-suggestion-conversions"
import type { Cart } from "@/types"

/** Records the storefront ORDER_PLACED and suggestion CONVERSION events of a confirmed order, whatever payment path resolved it. */
export function recordOrderConversion(cart: Cart, orderId: string): void {
  recordStorefrontOrderPlaced(orderId)
  recordSuggestionConversions(cart, orderId)
}
